export default __webpack_public_path__ + "static/media/market1.d41a488b.jpg";